import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import useIsMobile from 'hooks/useIsMobile'
import PATHS from 'utils/paths'

import { QUIZ_DIAGNOSTICS_MIN_SUPPORTED_WIDTH } from '../utils/quizDiagnosticsBreakpoints'

export const useQuizDiagnosticsMobileRedirect = (): boolean => {
  const { replace } = useHistory()
  const isUnsupportedViewport = useIsMobile(QUIZ_DIAGNOSTICS_MIN_SUPPORTED_WIDTH)

  useEffect(() => {
    if (!isUnsupportedViewport) {
      return
    }

    replace(PATHS.books)
  }, [isUnsupportedViewport, replace])

  return isUnsupportedViewport
}
